import React from 'react';
import {View} from 'react-native';
import {groupBg} from '../../../style/adminTools';

const NOTICE_LAYER_Z_INDEX = 4000;
const PHONE_NOTICE_BOTTOM = 200;

const NoticeLayer = ({phone, notice, children}) => (
  <View
    testID="tenantPageNoticeLayer"
    pointerEvents="box-none"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: NOTICE_LAYER_Z_INDEX
    }}
  >
    {notice ? (
      <View
        testID="tenantPageSideEffectsSlot"
        style={{
          position: 'absolute',
          bottom: phone ? PHONE_NOTICE_BOTTOM : 20,
          left: phone ? 16 : undefined,
          right: phone ? 16 : 20,
          width: phone ? undefined : 420,
          backgroundColor: groupBg,
          borderRadius: 6
        }}
      >
        {notice}
      </View>
    ) : null}
    {children}
  </View>
);

export default NoticeLayer;
